import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { Controls, Player } from "@lottiefiles/react-lottie-player";
import LoadingSRC from "../../assets/jsons/Loading.json";
import { Button } from "../../components/Button/index";
import { Input } from "../../components/Input";
import Form from "../../components/Form";
import { authApi } from "../../hooks/authApi";
import { ViewLogin } from "../Login/styles";

const RedefinirSenha: React.FC = () => {
  const { hash } = useParams();
  const navigate = useNavigate();

  const [validando, setValidando] = useState(true);
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [formValid, setFormValid] = useState(false);
  const [loading, setLoading] = useState(false);

  const linkInvalido = () => {
    Swal.fire({
      icon: "error",
      title: "Link inválido ou expirado",
      text: "Solicite uma nova redefinição de senha na tela de login.",
      confirmButtonText: "Ok",
    }).then(() => {
      navigate("/login");
    });
  };

  useEffect(() => {
    const validar = async () => {
      if (!hash) {
        linkInvalido();
        return;
      }

      const data = await authApi().verificaHashRedefinirSenha(hash);

      if (data && data.valido) {
        setUsuario(data.usuario);
        setValidando(false);
        return;
      }

      linkInvalido();
    };

    validar();
  }, [hash]);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (loading || !senha || senha !== confirmarSenha) return;

    setLoading(true);
    const data = await authApi().redefinirSenha(hash as string, senha, confirmarSenha);
    setLoading(false);

    if (data && data.sucesso) {
      Swal.fire({
        icon: "success",
        title: "Senha alterada com sucesso!",
        text: "Use a nova senha para acessar o painel.",
        confirmButtonText: "Ir para o login",
      }).then(() => {
        navigate("/login");
      });
      return;
    }

    if (data && data.motivo === "LINK_INVALIDO") {
      linkInvalido();
      return;
    }

    const text = (() => {
      if (data && data.error === "TOO_MANY_REQUESTS") {
        return "Muitas tentativas seguidas, tente novamente em alguns minutos!";
      }

      switch (data && data.motivo) {
        case "SENHA_CURTA":
          return "A senha precisa ter no mínimo 6 caracteres.";
        case "SENHAS_DIFERENTES":
          return "As senhas não conferem.";
        default:
          return "Erro inesperado ao alterar a senha. Tente novamente.";
      }
    })();

    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: text,
    });
  };

  return (
    <ViewLogin>
      <div className="login">
        <div className="topo-login">
          <div className="logo">
            <img
              src={require(`../../assets/images/logo-conecta-venda-horizontal.svg`).default}
              className="img-responsive logo-svg"
              title="Logo login"
            ></img>
          </div>
          <div className="icone-canto">
            <div className="icone">
              <img
                src={require(`../../assets/images/icons/icone-rocket.svg`).default}
                className="img-responsive icone-svg"
                title="Logo login"
              ></img>
            </div>
          </div>
        </div>
        <div className="bg-login">
          {validando ? (
            <Player
              autoplay
              loop
              src={LoadingSRC}
              style={{ height: "80px", width: "80px" }}
            >
              <Controls
                visible={false}
                buttons={["play", "repeat", "frame", "debug"]}
              />
            </Player>
          ) : (
            <>
              <div className="texto">
                Cadastre sua<br></br>nova senha
              </div>
              <span className="linha"></span>
              <div className="frase fonteTexto">
                Redefinindo a senha do usuário:
                <br />
                <strong>{usuario}</strong>
              </div>
              <Form
                id={"redefinir-senha-form"}
                onSubmit={handleSubmit}
                setFormValid={setFormValid}
              >
                <div className="form-group">
                  <Input
                    type="password"
                    placeholder="Nova senha"
                    value={senha}
                    minLength={6}
                    required
                    allowEye={true}
                    onChange={(newValue) => {
                      setSenha(newValue);
                    }}
                  />
                </div>
                <div className="form-group">
                  <Input
                    type="password"
                    placeholder="Repetir a nova senha"
                    value={confirmarSenha}
                    minLength={6}
                    required
                    allowEye={true}
                    isValid={{
                      isValidFunction: (value: string) => value === senha,
                      dependencies: [senha, confirmarSenha],
                    }}
                    invalidText="As senhas não conferem"
                    onChange={(newValue) => {
                      setConfirmarSenha(newValue);
                    }}
                  />
                </div>
                <div className="form-group">
                  <Button
                    className={`login-button ${formValid ? "" : "disabled"}`}
                    type="submit"
                    title="Salvar nova senha"
                    loading={loading}
                  ></Button>
                </div>
                <div className="form-group">
                  <div
                    className="esqueciSenha fonteRotulos"
                    onClick={() => navigate("/login")}
                  >
                    Voltar para o login
                  </div>
                </div>
              </Form>
            </>
          )}
        </div>
      </div>
    </ViewLogin>
  );
};

export default RedefinirSenha;
